<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置“陌生人短时记忆功能”打开、关闭</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			在视频流人脸识别过程中，设置打开、关闭“陌生人短时记忆功能”，该函数需要在SKFaceVideoTrackInit()成功后调用
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceStrangerShortMemory(boolean StrangerShortMemory)</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">StrangerShortMemory: true：打开“陌生人短时记忆”，false：关闭“陌生人短时记忆”</p>    
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">boolean类型，打开/关闭“陌生人短时记忆”结果，成功为true，失败为false 
</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//打开“陌生人短时记忆功能”
boolean res = skFace.SKFaceStrangerShortMemory(true);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceFamily-Android','视频接口','设置“陌生人短时记忆功能”打开、关闭'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/SKFaceSDKFamily/voideinitiali/VoideStranger.vue